type BodyStyleSnapshot = {
	overflow: string
	position: string
	top: string
	left: string
	right: string
	width: string
	backgroundColor: string
}

type LockPageScrollOptions = {
	scrollY: number
	backgroundColor?: string
}

export const lockPageScroll = ({ scrollY, backgroundColor = '#fafafa' }: LockPageScrollOptions): (() => void) => {
	const body = document.body
	const html = document.documentElement
	const themeColorMeta = document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')
	const themeColorSnapshot = Array.from(themeColorMeta).map(meta => ({
		meta,
		content: meta.content
	}))

	const bodyStyleSnapshot: BodyStyleSnapshot = {
		overflow: body.style.overflow,
		position: body.style.position,
		top: body.style.top,
		left: body.style.left,
		right: body.style.right,
		width: body.style.width,
		backgroundColor: body.style.backgroundColor
	}
	const htmlSnapshot = {
		overflow: html.style.overflow,
		backgroundColor: html.style.backgroundColor
	}

	body.style.overflow = 'hidden'
	body.style.position = 'fixed'
	body.style.top = `-${scrollY}px`
	body.style.left = '0'
	body.style.right = '0'
	body.style.width = '100%'
	html.style.overflow = 'hidden'
	body.style.backgroundColor = backgroundColor

	return () => {
		body.style.overflow = bodyStyleSnapshot.overflow
		body.style.position = bodyStyleSnapshot.position
		body.style.top = bodyStyleSnapshot.top
		body.style.left = bodyStyleSnapshot.left
		body.style.right = bodyStyleSnapshot.right
		body.style.width = bodyStyleSnapshot.width
		body.style.backgroundColor = bodyStyleSnapshot.backgroundColor
		html.style.overflow = htmlSnapshot.overflow
		html.style.backgroundColor = htmlSnapshot.backgroundColor
		themeColorSnapshot.forEach(({ meta, content }) => {
			meta.content = content
		})

		if (bodyStyleSnapshot.position !== 'fixed') {
			requestAnimationFrame(() => {
				window.scrollTo(0, scrollY)
			})
		}
	}
}
